<div class="dialog-container">
    <div class="dialog-header">
      <div class="header-content">
        <div class="icon-container">
           <i class="fa fa-share-square icon-btn"  aria-hidden="true"></i>
        </div>
        <div class="header-text">
          <h2 style="font-weight: 600">Share Documents</h2>
          <p>with " {{ data?.business_name }} " </p>
        </div>
      </div>
        <img class="close-button" (click)="onCancel()" src="assets/images/close-circle.svg" alt="Upload">
    </div>
  
    <div class="dialog-content">
      <form [formGroup]="searchForm">
      <!-- Category & Country Section -->
      <div class="form-row">
        <!-- Category Selection -->
        <div class="category-section">
          <h3 class="selchoose">Folders</h3>
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Select Folder</mat-label>
            <mat-select formControlName="categories" [compareWith]="compareCategory" (selectionChange)="onCategoryChange($event.value)">
              <mat-option *ngFor="let category of getCatgory" [value]="category">
                {{ category?.tagname }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <!-- Country Selection -->
        <div class="country-section">
          <h3 class="selchoose">Select Country</h3>
          <mat-form-field appearance="outline" class="full-width country-select-field">
            <mat-select formControlName="country" disableRipple (selectionChange)="onCountryChange($event.value)">
              <mat-select-trigger>
                <img *ngIf="getFlagUrl(searchForm.value.country)" [src]="getFlagUrl(searchForm.value.country)" alt="Flag"
                  width="20" style="margin-right: 8px;" />
                {{ searchForm.value.country }}
              </mat-select-trigger>

              <mat-option *ngFor="let item of citizen" [value]="item.country">
                <img [src]="getFlagUrl(item.country)" alt="{{ item.country }}" width="20" style="margin-right: 8px;" />
                {{ item.country }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
      <!-- Category & Country Section -->

        <!-- Search Section -->
        <div class="search-section">
          <div class="search-container">
            <i class="material-icons">search</i>
            <input matInput 
                   formControlName="searchQuery"
                   placeholder="Search for Document..."
                   (input)="onSearch()">
          </div>
        </div>
  
        <!-- Connection List -->
        <div class="connection-list">
        <div class="file-card" *ngFor="let file of allFiles; let i = index">
            <div class="file-info">
                <!-- <i class="fa fa-file-alt file-icon"></i> -->
                <img src="assets/images/file.svg" alt="Upload">
                <div>
                    <!-- <div class="file-name">{{ file.filename }}</div> -->
                    <div class="file-name">{{ getDoctypeName(file.doctype || file.name) }}</div>
                    <div class="file-desc">
                      {{ formatDate(file.created) }} - 
                      {{ formatSize(file.filesize) }}

                        <span *ngIf="formatDate(file.expiration_date)">
                          - {{ formatDate(file.expiration_date) }}
                        </span>

                    </div>
                </div>
            </div>
            <!-- <input type="checkbox"  class="select-checkbox" [checked]="file.selected"> -->
            <input type="checkbox" class="select-checkbox" [checked]="isSelected(file.id)" (change)="toggleSelection(file, $event)"
              name="selected_{{file.id}}">

        </div>

        <!-- No Documents Message -->
        <div class="no-docs" *ngIf="searchForm.get('categories')?.value !=='identity' && allFiles?.length === 0">
          No Document(s) found
        </div>
        </div>

          <div class="button-group">
            <button mat-button type="button" class="btn-secondary" (click)="onCancel()">Cancel</button>
            <button mat-raised-button color="primary" class="btn-primary" type="submit" (click)="onShare()">Share</button>
          </div>

      </form>
    </div>
</div>
